/** */
import {
  ADD_MANY_TRANSACTIONALS_TO_STORE,
  ADD_ONE_TRANSACTIONAL_TO_STORE,
  ADD_SEARCH_RESULTS,
  LOAD_TRANSACTIONALS_TO_STORE,
  READ_MANY_TRANSACTIONALS
} from '../actions/transactional';

export default (state = {}, action) => {
  const { type, payload } = action;
  const current_state = { ...state };
  switch (type) {
    case ADD_MANY_TRANSACTIONALS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (transactionals, transactional) => ({
            ...transactionals,
            [transactional.id]: transactional
          }),
          {}
        )
      };
    case ADD_ONE_TRANSACTIONAL_TO_STORE:
      return {
        [payload.id]: payload,
        ...state
      };
    case ADD_SEARCH_RESULTS:
      return {
        ...payload.reduce(
          (transactionals, transactional) => ({
            ...transactionals,
            [transactional.id]: transactional
          }),
          {}
        )
      };
    case LOAD_TRANSACTIONALS_TO_STORE:
      return {
        ...payload.reduce(
          (transactionals, transactional) => ({
            ...transactionals,
            [transactional.id]: transactional
          }),
          {}
        )
      };
    case READ_MANY_TRANSACTIONALS:
      payload.forEach((id) => {
        delete current_state[id];
      });

      return {
        ...current_state
      };
    default:
      return state;
  }
};
